import { render, staticRenderFns } from "./LeftMenuProject.vue?vue&type=template&id=044d64ee&"
import script from "./LeftMenuProject.vue?vue&type=script&lang=js&"
export * from "./LeftMenuProject.vue?vue&type=script&lang=js&"
import style0 from "./LeftMenuProject.vue?vue&type=style&index=0&id=044d64ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports